import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || props.name;
  return <div className="w-full" data-id="element-409">
      {label && <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-410">
          {label}
        </label>}
      <textarea id={textareaId} className={`w-full px-4 py-3 rounded-md border ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-cyan-500 focus:border-cyan-500'} shadow-sm focus:outline-none focus:ring-2 transition-colors ${className}`} {...props} data-id="element-411" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-412">{error}</p>}
    </div>;
}